import View from "../framework/view";
import template from "../../pugc/shop-collection";
import Server from "../server";
import {Collection} from "../bo/collection";
import {StringReorder} from "./string_reorder";

const classname = "shop-collection-view";

const server = Server.instance();

export class ShopCollectionView extends View {

    private loadedName: string;

    private collection?: Collection;

    private stringReorder: StringReorder | undefined;

    private productNames: string[] = [];

    constructor(name: string) {
        super(classname);
        this.loadedName = name;
        this.load();
    }

    async load() {
        const collections = await server.collections();
        this.collection = collections.filter(c => c.name == this.loadedName)[0];
        this.stringReorder = new StringReorder("product", this.collection.product_names || [], (productNames) => {
            this.updateProductNames(productNames);
        });
        // Take copy
        this.productNames = (this.collection.product_names || []).splice(0);
        this.update();
    }

    updateProductNames(productNames: string[]) {
        this.productNames = productNames;
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            collection: this.collection,
            stringReorder: this.stringReorder
        };

        const out = this.pug(template, data);

        return out;
    }

    async save() {
        const data: Collection = JSON.parse(JSON.stringify(this.collection)) as Collection;
        data.product_names = this.productNames;

        await server.saveCollection(data);
    }
}


View.on(
    "." + classname,
    "click",
    "button.save",
    function(that: ShopCollectionView, event, elt) {
        event.preventDefault();
        that.save();
    });

